export default {
    id:'pt',
    wellcome: {
        our_mission:'Nossa missão',
        our_vission: 'Nossa visão',
        our_values: 'Nossos valores',
        link: 'https://www.goodhope.org.pe/quienes-somos',
        more_information: 'Mais informações', 
        vission: 'Ser uma rede de saúde reconhecida pela excelência na assistência médico-hospitalar, prevenção e promoção de um estilo de vida saudável, integrando fé e ciência',
        mission: 'Servir, curar e salvar, promovendo a saúde física, mental, social e espiritual, seguindo o exemplo de cristo',
        values: ['Amor a Deus e ao Próximo', 'Respeito aos Princípios Bíblicos', 'Integridade, Ética e Transparência', ' Excelência em Servir', 'Acolhimento, Cuidado e Compaixão', 'Competência Técnica com Criatividade e Inovação', 'Sustentabilidade Financeira, Social e Ambiental'],
        slogan: 'Servir, Curar e Salvar',
        sloganLarge: ['Acredita na vida']
      
    },
    login: {
        user: 'Usuario',
        userPlaceholder: 'Meu usuario',
        password: 'Senha',
        passwordPlaceholder: 'Meu senha',
        button: 'Entrar',
        quest: '¿Você esqueceu sua senha?',
        forgotMessage: 'Entre em contato com Adventist Health',
        logoAdv : '',
        logoRed: '',
        exit:'Sair',
        error: {
            server_undefined: 'Não foi possível contatar o servidor.',
            server_error: 'Temos um problema ao validar suas credenciais',
            password : 'Credenciais inválidas'
        }
    },
    loading:{
        text: 'Procurando informações'
    },

    common: {
        save: 'Salvar',
        saving: 'Salvando',
        loading: 'Carregando',
        name: 'Nome',
        description: 'Descrição',
        error: 'Erro',
        type: 'Tipo',
        user: 'Usuário',
        option: 'Opção',
        options: 'Opções',
        option_short: 'Opç',
        leadership: 'Liderança',
        kpi: 'Indicador',
        kpis: 'Indicador | Indicadores',
        company: 'Empresa',
        plan: 'Planejamento',
        sector: 'Setor',
        period: 'Período',
        state: 'Estado',
        agreement : 'Acordo',
        group: 'Perspectiva',
        stereotype:'Estereótipo',
        acreditation: 'Acreditaçõe',
        perspective: 'Perspectiva',
        init: 'De',
        end: 'Para', 
        observation: 'Observação',
        comment: 'Comentário',
        code: 'Código',
        new: 'Novo',
        add: 'Agregar',
        edit: 'Editar',
        agreements: 'Acordo | Acordos',
        quality: 'Qualidade',
        control_managment: 'Gestão de controle',
        provider: 'Fornecedor',
        client: 'Cliente' ,
        date: 'Data',
        clean: 'Limpar',
        delete: 'Excluir',
        defuse: 'Desarmar',
        active: 'Ativar',
        total: 'Total',
        all: 'Todos',
        report: 'Relatório',
        download: 'Baixar',
        measure: 'medição',
        history: 'Registro',
        back:'Retornar',
        approve: 'Aprovar',
        yes: 'Sim',
        no: 'Não',
        points: 'Pontos',
        kpi_xs: 'KPI',
        search: 'Pesquiçar',
        role:'Papel',
        cancel:'Cancelar',
        update:'Atualizar',
        sorter: 'Ordem',
        manager: 'Colaborador',
        controller: 'Auditor',
        avaliador: 'Assessor',
        evaluator: 'Assesor',
        template: 'Modelo',
        created: 'Criado',
        updated:'Atualizado',
        saved: 'Salvado',
        progress: 'Cumplimiento',
        day:'Día',
        percentProgress: 'Porcentagem alcançada'
    },

    kpi:{
        upload_evidence: 'Carregar evidências',
        upload_file: 'Carregar arquivo',
        upload_see : 'veja evidências',
        upload_name : 'Nome do arquivo',
        attachment_file: 'Arquivos anexados',
        not_avariable: 'Não disponível',
        upload_set_file: 'Por favor subir un archivo',
        upload_set_name: 'Por favor ingresar un nombre',
        upload_ok : 'Se guardó el archivo',
        upload_ko: 'Error al guardar el archivo',
        upload_delete_ok: 'Se eliminó el archivo',
        upload_delete_ko: 'Error al eliminar archivo',
        upload_download_ko: 'Error al descargar archivo',

        stereotypes:'Estereótipos',
        acreditations: 'Acreditações',


        measure: 'insira a medição',
        write: 'Insira sua análise aqui',
        measure_ko: 'Não atingiu a meta',
        measure_ok: 'Você atingiu a meta',
        measure_value: 'Alcançado',
        analysis: 'Análise',
        formula: 'Fórmula',
        level: 'Nível',
        kpi: 'Indicador',
        goal: 'Meta',
        result: 'Alcançado',
        percent: '% Conformidade',
        method: 'Método',
        check: 'Avaliação',
        checker: 'Assessor',
        checked: 'Avaliado',
        history: 'Registro',
        history_title: 'Histórico de alterações',
        commentary: 'Comentário',
        measure_null: 'Ainda não temos dados',
        maxLength:'Tenha cuidado para não exceder o limite de caracteres permitido.',
        selectSector: 'Selecione um setor para continuar',
        configTitle: 'Gestão de indicadores',
        unit: 'Unidade',
        complete_no: 'Não cumprido',
        complete_yes: 'Cumpriu'

    },

    sector: {
        sector: 'Setor',
        search: 'Encontre um setor',
        form: 'Dados do setor',
        children: 'Setores associados',
        children_ko: 'Não tem setores associados',
        users: 'Usuarios relacionados',
        type: 'Tipo de setor',
        select_please: 'Selecione um setor',
        selectSector: 'Selecione um setor para continuar',
    },

    plan: {
        complete: 'No hay pendientes para este sector',
        doing: 'En progreso',
        action_plan: 'Plan de acción',
        kpi: 'Indicador (Indicador General KPI)',
        kpi_goal: 'Meta KPI',
        rk: 'KR - Resultado Clave',
        kr_actual: 'R Actual',
        kr_goal: 'Meta KR',
        kr_days: 'Tiempo (días)',
        kr_result: 'Resultado',
        reason: '¿Por qué lo hará? ',
        reason_description: 'Identifique el inicio del problema',
        reason_other: 'Otro motivo',
        plan_how_kr: '¿Cómo logrará el KR?',
        plan_what: '¿Qué se hará?',
        plan_how: '¿Cómo se hará?',
        plan_who: '¿Quién lo hará?',
        plan_when: '¿Cuándo se hará?',
        plan_where:  '¿Dónde se hará?',
        plan_cost: '¿Cuánto costará?',
        plan_when_description: 'colocar la cantidad de días que se realizará',
        do_init: 'Fecha inicio',
        do_end: 'Fecha final',
        check_advance: 'Tipo de avance',
        check_pass: 'Revisiones anteriores',
        collaboration: 'Colaboración',
        collaboration_sector: 'Sector a comunicar',
        collaboration_past: 'Comunicaciones pasadas',
        act: 'Comentarios para el área de calidad'

    },

    risk: {
        type: 'Tipo de riesgo por el incumplimiento del indicador',
        risk: 'riesgo en la experiencia del paciente por el incumplimiento del indicador',
        impact: 'Impacto por incumplimiento del indicador',
        category: 'Categoría ' ,
        operational: 'Criterio operacional',
        legal: 'Criterio regulatorio',
        finance:'Criterio financiero'
    },

    ose: {
        kpi: 'Datos del indicador',
        type: 'Tipo de indicador',
        class: 'Clasificación OSE'
    },

    checklist: {
        nothing: 'No hay indicadores tipo CHECKLIST para este sector',
        new: 'Nuevo checklist'
    },

    review : {
        result: 'Resultado',
        controller: 'Auditor',
        feedback: 'Assesor',
        complete: 'Cumplió la meta',
        evidence: 'Evidencia',
        analysis: 'Análisis',
        kpi_sector: 'INDICADORES RELACIONADOS POR SETORES'
    },
    
    agreement: {
        as_provider: 'Meus acordos com outros fornecedores',
        as_client: 'Meus acordos',
        motive: 'Motivo do contrato',
        time: 'Prazo',
        preview: 'Pré-requisito',
        my: 'Meu acordo',
        sign: 'Assinado em ',
        complete: 'Cumpriu o acordo',
        complete_ko: 'Motivo da não conformidade',
        confirm_message: 'Assinado em  {date} pelo usuário {user} ',
        confirm_title: 'Confirmar acordo',
        new:'Novo acordo',
        edit: 'Editar acordo',
        approve: 'Aprovar acordo',
        review: 'Avaliação do acordo',
        confirm_delete: 'Tem certeza de que deseja excluir este contrato?',
        period_out: 'Período fechado'
    },

    report : {
        title: 'Painéis',
        dashboard: {
            title: 'Dashboard',
            group_point : 'Distribuição de pontuação por perspectiva',
            stereotype_point: 'Distribuição de pontuação por estereótipo',
            total_point: 'Total de pontos',
            percent: 'Porcentagem alcançada',
            kpi_detail: 'Lista detalhada de indicadores',
            average: 'Média'
        },
        ranking : {
            title: 'Ranking',
            unit: 'Unidad administrativa'
        },
        history: {
            title: 'Histórico'
        },
        plan: {
            title: 'Planos'
        },
        accreditation:{
            title: 'credenciamento'
        },
        ose: {
            title: 'OSE'
        },
        risk: {
            title: 'Risco'
        },
        epr: {
            title : 'ERP',
            perspectiveChart:'Distribuição por perspectiva',
            percent: 'Porcentagem alcançada',
            distribution: 'Distribuição por EPR',
            abstract: 'Resumo',
            no_classification: 'Não atribuído'
        }
    },

    config: {
        title: 'Configurações',
        company:'Configuração da empresa',
        basic: 'Configurações básicas',
        menu : {
            user: 'Usuários',
            plan: 'Planejamento',
            objetive: 'Tipo de objetivos',
            sectorType: 'Tipo de setores',
            leadership: 'Liderança',
            smtp: 'SMTP',
            sectors: 'Setores',
            groups: 'Perspectivas',
            periods: 'Períodos',
            stereotypes : 'Estereótipos',
            blocks: 'Fechaduras',
            integrations: 'Integrações',
            template: 'Modelos',
            kpi: 'Indicadores',
            objetives: 'Objetivos',
            ranking: 'Cálculos'
        },
        users:{
            title: 'Gerenciamento de usuários',
            search:'Pesquisar usuário',
            newUser:'Novo usuário',
            confirmDelete: 'Tem certeza de que deseja excluir o usuário da instituição?',
            create:'Criar usuário',
            import: 'Importar usuário',
            userExists: 'Usuário já registrado',
            personalData: 'Dados pessoais',
            credentials: 'Credenciais',
            addSector: 'Adicionar setor',
            successfull: 'Usuário criado'
            
        },
        sector:{
            title: 'Gestão de setores',
            delete: 'Excluir setor',
            deleteMessage: 'Excluir um setor pode afetar muito o sistema, exclua com responsabilidade.'
        },
        sectorType: {
            title: 'Gestão de tipo de setor',
            kpiMark: 'Rótulo dos indicadores',
            level: 'Nível',
            asesor: 'Assessor',
            kpiLetter: 'Carta representativa',
            new: 'Novo tipo de setor'
        },
        period: {
            title: 'Gestão do período',
            start: 'Data de início',
            end: 'Data de término',

        },
        kpi:{
            title: 'Formulário de edição de indicadores',
            new: 'Novo indicador',
            createFromTemplate: 'Criar a partir do modelo',
            kpiChildren: 'Indicadores relacionados',
            kpiFather: 'Indicador pai',
            method: 'Método',
            integrations: 'Integrações',
            kpiData: 'Dados indicadores',
            generalData: 'informações gerais',
            pdca: 'Este indicador se qualifica para PDCA',
            delete: 'Excluir um KPI pode causar instabilidade no sistema. A eliminação também envolve a remoção de KPIs relacionados de outros setores. Use com cautela',
            confirmDelete: 'Tem certeza de que deseja excluir?',
            withoutTemplate: 'Nenhum modelo'


        }
    },
    menu: {
        operational: 'Análise Operacional',
        tactic: 'Análise Tática',
        strategic: 'Análise Estratégica',
        plan: 'PDCA-5W2H-OKR',
        process: 'Processos',
        map: 'Mapa Estratégico',
        risk: 'Gestão de Risco e Experiência',
        ose: 'OSE',
        epr: 'EPR-SCS',
        checklist: 'Checks',
        advance: 'Avanços',
        review: 'Avaliar',
        agreement: 'Acordos',
        report: 'Painéis',
        config: 'Configurações'
    },
    process:{
        register: 'Log de processo',
        add:'Adicionar processo',
        confirmDelete: 'Tem certeza de que deseja excluir?',
    },
    ose:{
        title: 'Eficiência geral do serviço',
        kpiType:'Tipo de indicador',
        areaSelect: 'Selecione a área',
        classification: 'Classificação OSE',
        classificationSelect: 'Selecione uma classificação',
        detail:'Insira um detalhe',
        error:'Preencha o formulário',
        registed: 'Registrados',
        unckecked: 'registro pendente',
        order: 'Distribuição OSE',
        kpiCount: 'Número de indicadores',
        chartTitle: 'Número de indicadores por classificação OSE',
        chartSubTitle: 'Indicadores por OSE',
        unassigned: 'Não atribuído',
        kpiList: 'Lista de indicadores',
        kpiRecord: 'Indicadores registrados',
        kpiPercent: 'Porcentagem de conformidade'
    },
    progress: {
        title: 'Progresso da conclusão dos Indicadores',
        grade: 'Avaliações',
        no_grade: 'Nenhuma avaliação',
        get_data: 'Obter informações de setores relacionados'
    },
    evaluation:{
        title: 'Avaliar indicadores',
        profile: 'Perfil'
    },
    epr:{
        title: 'Estrutura, Processos e Resultados',
        kpiList: 'Lista de indicadores',
        slogan: 'Lema'
    }
}


